import {ColDefCustom} from "../components/agGridCustom/agGridVueCustomTsx";
import {IconBtnItem} from "../components/iconBtnGroup/iconBtnGroup";
import {QueryFormVOI} from "../components/queryForm/queryForm";

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 10:06 2020/3/26
 */

export default class ListPageService {

	// 查询表格
	initSearchParams(): void {}

	// 查询表格
	searchTable(): void {}

	// 清空表单
	clearSearchForm(): void {}

	// 创建列
	createColumns (): ColDefCustom[] {return  []}

	// 创建btngroup
	createBtnGroup (): Array<IconBtnItem> {return  []}

	// 创建查询条件
	creatQueryForm(): Array<QueryFormVOI.DateItemType> {return []}

	// 拖动行
	dragRow(event: any): void {}
}
